import * as betprofessor from './NextToJumpItem.styles.betprofessor';
import * as betroyale from './NextToJumpItem.styles.betroyale';
import * as fiestabet from './NextToJumpItem.styles.fiestabet';
import * as goldenrush from './NextToJumpItem.styles.goldenrush';
import * as juicybet from './NextToJumpItem.styles.juicybet';
import * as puntcity from './NextToJumpItem.styles.puntcity';
import * as puntgenie from './NextToJumpItem.styles.puntgenie';
import * as questbet from './NextToJumpItem.styles.questbet';
import * as sterlingparker from './NextToJumpItem.styles.sterlingparker';
import * as vikingbet from './NextToJumpItem.styles.vikingbet';
import * as volcanobet from './NextToJumpItem.styles.volcanobet';
import * as wellbet from './NextToJumpItem.styles.wellbet';
import * as forsport from './NextToJumpItem.styles.forsport';
import * as junglebet from './NextToJumpItem.styles.junglebet';
import * as sugarcastle from './NextToJumpItem.styles.sugarcastle';
import * as oldgill from './NextToJumpItem.styles.oldgill';
import * as buffalobet from './NextToJumpItem.styles.buffalobet';
import * as titanbet from './NextToJumpItem.styles.titanbet';
import * as templebet from './NextToJumpItem.styles.templebet';
import * as slambet from './NextToJumpItem.styles.slambet';
import * as gigabet from './NextToJumpItem.styles.gigabet';
import * as betstride from './NextToJumpItem.styles.betstride';
import * as goldenbet888 from './NextToJumpItem.styles.goldenbet888';
import * as hyperbet from './NextToJumpItem.styles.hyperbet';
import * as bet777 from './NextToJumpItem.styles.bet777';
import * as chromabet from './NextToJumpItem.styles.chromabet';
import * as bet575 from './NextToJumpItem.styles.bet575';
import * as epicodds from './NextToJumpItem.styles.epicodds';
import * as pyramidbet from './NextToJumpItem.styles.pyramidbet';
import * as magnumbet from './NextToJumpItem.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  templebet,
  slambet,
  gigabet,
  betstride,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
